import client from './client';

export async function listLeadSources(params) {
  const { data } = await client.get('/lead-sources', { params });
  return data.data;
}

export async function createLeadSource(payload) {
  const { data } = await client.post('/lead-sources', payload);
  return data.data;
}

export async function updateLeadSource(id, payload) {
  const { data } = await client.put(`/lead-sources/${id}`, payload);
  return data.data;
}

export async function deleteLeadSource(id) {
  await client.delete(`/lead-sources/${id}`);
}

export async function listNationalities(params) {
  const { data } = await client.get('/nationalities', { params });
  return data.data;
}

export async function createNationality(payload) {
  const { data } = await client.post('/nationalities', payload);
  return data.data;
}

export async function updateNationality(id, payload) {
  const { data } = await client.put(`/nationalities/${id}`, payload);
  return data.data;
}

export async function deleteNationality(id) {
  await client.delete(`/nationalities/${id}`);
}

export async function listRejectionReasons(params) {
  const { data } = await client.get('/rejection-reasons', { params });
  return data.data;
}

export async function createRejectionReason(payload) {
  const { data } = await client.post('/rejection-reasons', payload);
  return data.data;
}

export async function updateRejectionReason(id, payload) {
  const { data } = await client.put(`/rejection-reasons/${id}`, payload);
  return data.data;
}

export async function deleteRejectionReason(id) {
  await client.delete(`/rejection-reasons/${id}`);
}

export async function listBulkRequestTypes(params) {
  const { data } = await client.get('/bulk-request-types', { params });
  return data.data;
}

export async function createBulkRequestType(payload) {
  const { data } = await client.post('/bulk-request-types', payload);
  return data.data;
}

export async function updateBulkRequestType(id, payload) {
  const { data } = await client.put(`/bulk-request-types/${id}`, payload);
  return data.data;
}

export async function deleteBulkRequestType(id) {
  await client.delete(`/bulk-request-types/${id}`);
}
